import { Button } from "@/components/flexkit/Button";
import { Text } from "@/components/podkit/typography/Text";
import { SecretLabels } from "@/components/secrets/secret-labels";
import { SecretsTable } from "@/components/secrets/SecretsTable";
import { type PlainSecret } from "@/queries/secret-queries";
import { type FC, type PropsWithChildren } from "react";
import { type SecretScope } from "gitpod-next-api/gitpod/v1/secret_pb";
type Props = {
    scope: SecretScope;
    secrets: PlainSecret[];
    onNewSecret: () => void;
    showCreatorColumn?: boolean;
};

export const SecretsCard: FC<Props> = ({ scope, secrets, onNewSecret, showCreatorColumn = true }) => {
    return (
        <SecretsFrame>
            {secrets.length ? (
                <SecretsTable secrets={secrets} onNewSecret={onNewSecret} showCreatorColumn={showCreatorColumn} />
            ) : (
                <SecretsEmptyState scope={scope} onNewSecret={onNewSecret} />
            )}
        </SecretsFrame>
    );
};

// this is reused for showing secrets in the environment details
export const SecretsFrame: FC<PropsWithChildren> = ({ children }) => {
    return (
        <div className="flex w-full justify-center rounded-xl border border-border-base bg-surface-glass px-4 py-3">
            {children}
        </div>
    );
};

const SecretsEmptyState: FC<{ scope: SecretScope; onNewSecret: () => void }> = ({ scope, onNewSecret }) => {
    const mode = scope.scope.case === "projectId" ? "project" : "user";
    return (
        <div className="flex flex-col gap-2 px-4 py-8" data-testid="secrets-empty-state">
            <Text className="text-base text-content-tertiary">{SecretLabels[mode].emptyStateDescription}</Text>
            <Button
                variant="secondary"
                size={"md"}
                onClick={() => onNewSecret()}
                data-testid="add-secret-modal-trigger"
            >
                New secret
            </Button>
        </div>
    );
};
